import { gsap } from 'gsap';
import { animationTrigger } from '../common';
import { initProductDialogs } from '../components/productDialog';
import { initDialog } from '../lib/dialog';

export function initCatalogPage() {
  const items = document.querySelectorAll('.catalog-grid__item');
  items.forEach((item, index) => {
    if (!item) return;

    const card = item.querySelector('.product-card');
    const dialog = initDialog(card.dataset.dialog);
    card.addEventListener('click', () => {
      dialog.show();
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: animationTrigger,
        once: true,
        toggleActions: 'play none none none',
        // markers: true,
      },
    });

    tl.fromTo(
      item,
      { opacity: 0, scale: 0.8, transformOrigin: 'center center' },
      {
        opacity: 1,
        scale: 1.0,
        duration: 0.5,
        ease: 'power1.out',
        delay: index * 0.05,
      },
    );
  });

  initProductDialogs();

  console.log('📄 Catalog page initialized.');
}
